import {
  amoutStrToBaseUnitQuantity,
  baseUnitQuantityToAmountString,
} from '@shared/utils';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { Button, Group, Input, NumberField } from 'react-aria-components';

export function InputMoney({
  value,
  onChange,
}: {
  value: number;
  onChange?: (value: number) => void;
}) {
  return (
    <NumberField>
      <div className="space-y-2">
        <Group className="border-input data-[focus-within]:border-ring data-[focus-within]:ring-ring/20 relative inline-flex h-9 w-full items-center overflow-hidden whitespace-nowrap rounded-lg border text-sm shadow-sm shadow-black/5 transition-shadow data-[disabled]:opacity-50 data-[focus-within]:outline-none data-[focus-within]:ring-[3px]">
          <Input
            className="bg-background text-foreground peer w-20 flex-1 px-3 py-2 pe-12 ps-6 tabular-nums focus:outline-none"
            value={baseUnitQuantityToAmountString({ baseUnitQuantity: value })}
            onChange={(e) => {
              onChange?.(
                amoutStrToBaseUnitQuantity({ amountStr: e.target.value }),
              );
            }}
          />

          <span className="text-muted-foreground pointer-events-none absolute inset-y-0 start-0 flex items-center justify-center ps-3 text-sm peer-disabled:opacity-50">
            $
          </span>

          <div className="flex h-[calc(100%+2px)] flex-col">
            <Button
              slot="increment"
              onPress={() => {
                onChange?.(value + 100);
              }}
              className="border-input bg-background text-muted-foreground/80 hover:bg-accent hover:text-foreground -me-px flex h-1/2 w-6 flex-1 items-center justify-center border text-sm transition-shadow disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50"
            >
              <ChevronUp size={12} strokeWidth={2} aria-hidden="true" />
            </Button>

            <Button
              slot="decrement"
              onPress={() => {
                onChange?.(Math.max(value - 100, 0));
              }}
              className="border-input bg-background text-muted-foreground/80 hover:bg-accent hover:text-foreground -me-px -mt-px flex h-1/2 w-6 flex-1 items-center justify-center border text-sm transition-shadow disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50"
            >
              <ChevronDown size={12} strokeWidth={2} aria-hidden="true" />
            </Button>
          </div>
        </Group>
      </div>
    </NumberField>
  );
}
